import { Observable, of } from 'rxjs';

export const UNDEFINED = of(undefined);

export function UNDEFINED_TYPE<T>(): Observable<T> {
  return of<T>(undefined);
}
